import { ModuleEnum } from './enums';

export const ROUTE_ROOT = '/';
export const ROUTE_DASHBOARD = '/dashboard';
export const ROUTE_LOGIN = '/login';
export const ROUTE_LOGIN_CALLBACK = '/login_callback';
export const ROUTE_HOME = '/Home';
export const ROUTE_FRAME = '/Frame/*';
export const ROUTE_FRAME_CONFIG = '/Frame/config/:configName';
export const ROUTE_MODULE_BRIEFING = '/Briefing';
export const ROUTE_MODULE_PATH_TO_GROWTH = '/PathToGrowth';
export const ROUTE_MODULE_INSPIRE = '/Inspire';
export const ROUTE_MODULE_PLANNING = '/Planning';
export const ROUTE_MODULE_AUDIENCE = '/Audience';
export const ROUTE_MODULE_OPTIMIZE_AND_REPORTING = '/OptimizeAndReport';
export const ROUTE_MODULE_ACTIVATION = '/Activation';
export const ROUTE_MODULE_CONFIG = '/Config';
export const ROUTE_MODULE_CAMPAIGN_MONITOR = '/CampaignMonitor';
export const ROUTE_MODULE = '/:module';
export const ROUTE_FRAME_BRAND_CUSTOMIZATION = '/Frame/ThemeCustomization';
export const ROUTE_FRAME_THEMES = '/Frame/Themes';

export const RouteToModule = (module: ModuleEnum) => {
  switch (module) {
    case ModuleEnum.Cockpit:
      return ROUTE_HOME;
    case ModuleEnum.Briefing:
      return ROUTE_MODULE_BRIEFING;
    case ModuleEnum.Growth:
      return ROUTE_MODULE_PATH_TO_GROWTH;
    case ModuleEnum.Inspire:
      return ROUTE_MODULE_INSPIRE;
    case ModuleEnum.Planning:
      return ROUTE_MODULE_PLANNING;
    case ModuleEnum.Audience:
      return ROUTE_MODULE_AUDIENCE;
    case ModuleEnum.Activation:
    case ModuleEnum.Investment:
      return ROUTE_MODULE_ACTIVATION;
    case ModuleEnum.Reporting:
      return ROUTE_MODULE_OPTIMIZE_AND_REPORTING;
    case ModuleEnum.Config:
      return ROUTE_MODULE_CONFIG;
    case ModuleEnum.CampaignMonitor:
      return ROUTE_MODULE_CAMPAIGN_MONITOR;
    default:
      return `/${module}`;
  }
};
